import {Component} from "@angular/core";
import {Names} from "../names";
import {BrandingService} from "../Branding/BrandingService"

@Component({
    selector: Names.environment.selector,
    template: require("./EnvironmentComponent.html")
})
export class EnvironmentComponent {
    show: boolean;
    environment: string;
    buildNumber: string;

    constructor(private brandingService: BrandingService) {
        const config = this.brandingService.getSystemConfiguration();

        this.show = config.EnvironmentBannerEnabled.toString() === "true";
        this.environment = config.Environment;
        this.buildNumber = config.ReleaseNumber;
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Environment/EnvironmentComponent.ts